<template>

    <div v-if="show" class="flex flex-col md:flex-row mb-10 item justify-left items-center">

        <div class="rounded-lg w-full md:w-1/3 shadow-md flex items-center h-32 foto" :style="{backgroundImage: 'url(' + image + ')' }"></div>
        <div class="pl-6 ">
            <div class="text-gray-800 my-6 text-2xl capitalize">{{item.lastname}}, {{item.name}}<br>
                <span v-if="item.type==`ilustrador`" class="bg-theme-sky text-white px-3 py-1 text-xs rounded tracking-widest ">ILUSTRADOR</span>
                <span v-if="item.type==`ilustradora`" class="bg-theme-sky text-white px-3 py-1 text-xs rounded tracking-widest ">ILUSTRADORA</span>
                <span v-if="item.type==`escritor`" class="bg-theme-blue text-white px-3 py-1 text-xs rounded tracking-widest ">ESCRITOR</span>
                <span v-if="item.type==`escritora`" class="bg-theme-blue text-white px-3 py-1 text-xs rounded tracking-widest ">ESCRITORA</span>
            </div>  

            <div class="autores-item-links my-1">
                <router-link class="text-theme-sky uppercase text-sm font-bold " :to="{name:'AutorDetail', params: {id:item.id}}">Ver más</router-link>
            </div>

        </div>
    </div>    

</template>

<script>
export default {


    props: ['item', 
            'filtroInput'],

    data(){
        return {
            image: this.item.image,
            type: this.item.type,
            filtro: "",
            show: true
        }
    },
    methods:{
        cleanString(value){
            let str = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            return str.normalize('NFD').replace(/[\u00C0-\u00FF]/g, '');
        }
    },
    watch:{
        filtroInput:function(){

            let name = this.cleanString(this.$props.item.name.toLowerCase())
            let lastname = this.cleanString(this.$props.item.lastname.toLowerCase())
            let filtro = this.cleanString(this.$props.filtroInput.toLowerCase())

            console.log(name, lastname, filtro)

            if(name.includes(filtro) ||
                lastname.includes(filtro) ){
                this.show = true
            }else{
                this.show = false
            }


            // if(this.$props.item.name.toLowerCase().includes(this.$props.filtroInput.toLowerCase()) ||
            //     this.$props.item.lastname.toLowerCase().includes(this.$props.filtroInput.toLowerCase()) ){
            //     this.show = true
            // }else{
            //     this.show = false
            // }
        }
    }
}
</script>
<style scoped>
.foto{
    background-size: cover;
    background-position: center center;
}

</style>